import { collector } from "../collector";

// One delegated capture-phase listener catches clicks even if a React handler
// calls stopPropagation(). Prefer explicit data-diag labels; fall back to text.
export function startClick() {
  const handler = (e) => {
    const target = e.target;
    if (!target || typeof target.closest !== "function") return;
    const el = target.closest("[data-diag], button, a[href], [role='button']");
    if (!el) return;

    const label =
      el.getAttribute("data-diag") ||
      (el.textContent || "").trim().slice(0, 40) ||
      el.getAttribute("aria-label") ||
      el.tagName.toLowerCase();

    collector.track("click", {
      label,
      tag: el.tagName.toLowerCase(),
      // e.isTrusted === false => synthetic/injected event (possible automation)
      trusted: e.isTrusted,
    });
  };

  document.addEventListener("click", handler, true);
  return () => document.removeEventListener("click", handler, true);
}
